import React from 'react'
import { RetentionResourceType } from '../../../models/RetentionPolicy'

export const RetentionPolicyResourceType: React.FC<{ type: RetentionResourceType }> = ({ type }) => {
  if (type === RetentionResourceType.SESSION) {
    return <div>Meeting</div>
  }
  if (type === RetentionResourceType.FILE) {
    return <div>File</div>
  }
  if (type === RetentionResourceType.AUDIT_LOG) {
    return <div>Audit log</div>
  }
  if (type === RetentionResourceType.DOCUMENT) {
    return <div>Document</div>
  }
  return <div>{type}</div>
}
